import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import React from "react";
import {useTranslation} from "react-i18next";
import {useCourierFilter} from "../context/useCourierFilter";
import {Radio} from "antd";

const CriminalRecordWithRadioButton = () => {
    const {t} = useTranslation(["common"]);
    const {dispatch, state} = useCourierFilter();

    const handleCriminalRecordChange = e => {
        dispatch({type: "hasCriminalRecord", payload: e.target.value});
    };

    const handleCriminalRecordClick = value => {
        if (state.hasCriminalRecord === value) {
            dispatch({type: "hasCriminalRecord", payload: undefined});
        }
    };

    return (
        <VFlex vertical minWidth={150} flex>
            <h5>{t("fields.hasCriminalRecord", {ns: "common"})}</h5>
            <Radio.Group value={state.hasCriminalRecord} onChange={handleCriminalRecordChange}>
                <Radio value={true} onClick={() => handleCriminalRecordClick(true)}>
                    Var
                </Radio>
                <Radio value={false} onClick={() => handleCriminalRecordClick(false)}>
                    Yok
                </Radio>
            </Radio.Group>
        </VFlex>
    );
};

export default CriminalRecordWithRadioButton;
